import React, { useCallback, useState } from 'react';
import { Flex, Heading } from '@chakra-ui/react';
import { Transaction } from '../../domain/transaction';
import { TransactionDetailModal } from './components/TransactionDetail';
import { TransactionFilters } from './components/TransactionFilters';
import { TransactionFiltersQueryParams, useTransactionFilters } from './hooks/useTransactionFilters';
import { TransactionTable } from './components/TransactionTable';
import { DateRange } from '../../components/DateRangeSelector/DynamicDateRange';

const Transactions = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedTransaction, setSelectedTransaction] = useState<Transaction | null>(null);
  const { results, loading, nextPage, prevPage, queryParams, search, updateParams, resetFilters } = useTransactionFilters();

  const toggleModal = (transaction?: Transaction) => {
    setSelectedTransaction(transaction || null);
    setShowModal(!showModal);
  };

  const handleUpdate = useCallback((value: string | undefined, key: keyof TransactionFiltersQueryParams) => {
    if (value === 'all') {
      search(key, undefined);
      return;
    }
    search(key, value);
  }, [search]);

  return (
    <Flex direction="column" height="100%" overflowY="auto">

      {selectedTransaction &&
        <TransactionDetailModal showModal={showModal} transaction={selectedTransaction} close={() => toggleModal()} />
      }

      <TransactionFilters
        onUpdateFilters={handleUpdate}
        queryParams={queryParams}
        updateParams={updateParams}
        handleResetQueryParamsFilters={resetFilters} />

      <TransactionTable
        dataLoading={loading}
        results={results}
        onSelectTransaction={toggleModal}
        onNextPage={nextPage}
        onPreviousPage={prevPage} />

    </Flex>
  )
    ;
};

export default Transactions;
